export const dialogRules = {
  cargoType: [{ required: true, message: '请选择货物类型' }],
  // weight: [
  //   { required: true, message: '请输入重量/数量' },
  //   // { type: 'number', message: '请输入数字' },
  // ],
  weightUnit: [{ required: true, message: '请选择单位' }],
};
